import { useMutation, useQueryClient } from '../../lib';
import { useTribeClient } from '../../useTribeClient';
import { getMembersKey } from '../../utils/keys';
export const useAddSpaceMember = (options) => {
    const { useMutationOptions } = options || {};
    const { client } = useTribeClient();
    const queryClient = useQueryClient();
    return useMutation(input => client.spaceMembers.add(input), {
        onSettled: (data, error, variables) => {
            const membersKey = getMembersKey({
                spaceId: variables.spaceId,
                limit: undefined,
            });
            queryClient.invalidateQueries(membersKey);
        },
        ...useMutationOptions,
    });
};
//# sourceMappingURL=useAddSpaceMember.js.map